import { Controller } from "@hotwired/stimulus";
import CSVBoxImporter from "@csvbox/csvboxjs";
import { getCSRFToken } from "../components/utils/various";

export default class CsvBoxUsersController extends Controller {
  static values = {
    key: String,
    groupId: String,
    endpoint: String,
    method: String,
  };

  connect() {
    this.importer = new CSVBoxImporter(this.keyValue, {}, this.callback.bind(this));

    this.importer.setUser({ group_id: this.groupIdValue });

    this.importer.setOptions({
      language: "fr",
    });

    this.element.onclick = () => {
      this.importer.openModal();
    };
  }

  get csrfToken() {
    return getCSRFToken();
  }

  async callback(result, data) {
    var add_current_user = document.getElementById("add_current_user_to_company");

    const content = {
      group_id: this.groupIdValue,
      add_current_user_to_company: add_current_user.checked,
      rows: data.rows.map((row) => ({
        company: {
          displayed_name: row.displayed_name,
          email: row.email_company,
          phone: row.phone,
          website: row.website,
          zip_code: row.zip_code,
        },
        user: {
          email: row.email,
          first_name: row.first_name,
          last_name: row.last_name,
        },
      })),
    };

    const response = await fetch(this.endpointValue, {
      method: this.methodValue || "POST",
      headers: {
        "X-CSRF-Token": this.csrfToken,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(content),
    });

    const responseData = await response.json();

    if (responseData.redirect_url) {
      window.location.href = responseData.redirect_url;
    }
  }
}
